import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {IconButtonComponent} from '@shared/components/icon-button/icon-button.component';

@Component({
  selector: 'od-snackbar-content',
  templateUrl: './snackbar-content.component.html',
  styleUrl: './snackbar-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconButtonComponent],
})
export class SnackbarContentComponent {
  public data = inject<string>(MAT_SNACK_BAR_DATA);
  public snackBarRef = inject(MatSnackBarRef<SnackbarContentComponent>);
}
